import React, { useState, useEffect } from "react";
import Header from "./Header";
import Hero from "./Hero";
import ServiceFinder from "./ServiceFinder";
import FeaturedServices from "./FeaturedServices";
import JoinCommunitySection from "./JoinCommunitySection";
import ViewAllService from "./ViewAllService";
import MyYuukke from "../../api/MyYuukke";
import SpecializationService from "../../api/SpecializationService";
import WomenConnectLoginpage from "./WomenConnectLoginpage";
import WomenConnectSignup from "./WomenConnectSignup";
import AboutWomenConnect from "./AboutWomenConnect";
import "./WomenLandingPage.css";
import { Helmet } from "react-helmet";

// Cover images setup, adjust paths as needed
import Cover1 from "../../images/category-lifestyle.jpg";
import Cover2 from "../../images/category-education.jpg";
import Cover3 from "../../images/category-consulting.jpg";
import Cover4 from "../../images/category-financial.jpg";
import Cover5 from "../../images/category-marketing.jpg";
import Cover6 from "../../images/category-wellbeing.jpg";

const COVER_IMAGES = {
  1: Cover1,
  2: Cover2,
  3: Cover3,
  4: Cover4,
  5: Cover5,
  6: Cover6,
};

const WomenConnectLanding = () => {
  const [activeSpec, setActiveSpec] = useState(null);
  const [businessData, setBusinessData] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeCoverImage, setActiveCoverImage] = useState(COVER_IMAGES[1]);
  const [showAllServices, setShowAllServices] = useState(false);
  const [showLoginPage, setShowLoginPage] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [categories, setCategories] = useState([]);
  
  // New states for specializations and search
  const [searchResults, setSearchResults] = useState({ specializations: [], categories: [] });
  const [searchLoading, setSearchLoading] = useState(false);

  


  useEffect(() => {
  fetchDirectoryCategories();
}, []);

const fetchDirectoryCategories = async () => {
  try {
    const res = await MyYuukke.getCategoryListV2();
    if (res.data.status === 1) {
      console.log("✅ Directory Categories:", res.data.data);
      setCategories(res.data.data);
      // You can store it in a new state if needed
      // setCategories(res.data.data);
    } else {
      console.warn("⚠️ No categories found");
    }
  } catch (err) {
    console.error("❌ Error fetching directory categories:", err);
  }
};


  // Fetch specializations/categories based on search keyword
  const fetchSpecializations = async (keyword = "") => {
    setSearchLoading(true);
    try {
      const res = await SpecializationService.getSpecializationForMarkertplace({
        searchKey: keyword,
      });
      if (res.data.status === 1) {
        setSearchResults(res.data.data);

        // Set default active specialization if not already set
        if (!activeSpec && res.data.data.specializations.length > 0) {
          setActiveSpec(res.data.data.specializations[0].id);
          // Also fetch services for the first specialization
          fetchServicesByCategory(res.data.data.specializations[0].id);
        }
      } else {
        setSearchResults({ specializations: [], categories: [] });
      }
    } catch (err) {
      console.error("Fetch specializations error:", err);
      setSearchResults({ specializations: [], categories: [] });
    } finally {
      setSearchLoading(false);
    }
  };

  // Updated fetch services function to handle both specialization and category
const fetchServicesByCategory = async (specId, categoryId = null, searchValue = "", searchLocation = "") => {
  setLoading(true);
  try {
    // 👇 Combine both searchValue and searchByLocation in formValues
    const formValues = {
      primaryId: specId,
      categoryId: categoryId, 
      searchValue: searchValue || "", // keyword from search bar
      searchByLocation: searchLocation || "", // location field from Hero
    };
    
    if (specId) {
      setActiveCoverImage(COVER_IMAGES[specId] || COVER_IMAGES[1]);
    }

    console.log("🚀 Sending search request:", formValues);

    const res = await MyYuukke.searchServiceByCategoryV2(formValues);

    if (res.data.status === 1) {
      const { businessData = [], services = [] } = res.data.data;
      setBusinessData(businessData);
      setServices(services);
    } else {
      setBusinessData([]);
      setServices([]);
    }
  } catch (err) {
    console.error("❌ Service fetch failed:", err);
    setBusinessData([]);
    setServices([]);
  } finally {
    setLoading(false);
  }
};




const handleHeroSearch = (keyword, location) => {
  console.log("🔎 Searching for:", keyword, "in", location);
  // You can send keyword and location to the same fetch function
  fetchServicesByCategory(activeSpec, null, keyword, location);
};






  // Handle search from ServiceFinder
  const handleSearch = (keyword) => {
    fetchSpecializations(keyword);
  };

  // Handle specialization selection
  const handleSpecSelection = (specId) => {
    setActiveSpec(specId);
    fetchServicesByCategory(specId);
  };

  // Load initial data
  useEffect(() => {
    fetchSpecializations("");
  }, []);

  // Navigation handlers
  const handleBackToHome = () => {
    setShowAllServices(false);
    setShowAbout(false);
    setShowLoginPage(false);
    setShowSignup(false);
  };

  // Show Login Page
  if (showLoginPage) {
    return (
      <div className="women-loginpage-container">
        <WomenConnectLoginpage onBack={() => setShowLoginPage(false)} />
      </div>
    );
  }

  // Show Signup Page
  if (showSignup) {
    return (
      <div className="women-signuppage-container">
        <WomenConnectSignup onBack={() => setShowSignup(false)}  bussinessCategories={categories}/>
      </div>
    );
  }

  // Show About Page
  if (showAbout) {
    return (
      <div className="women-aboutpage-container">
        <AboutWomenConnect 
          onBack={handleBackToHome}
          onSignIn={() => {
            setShowAbout(false);
            setShowLoginPage(true);
          }}
          onJoinNow={() => {
            setShowAbout(false);
            setShowSignup(true);
          }}
          onServices={() => {
            setShowAbout(false);
            setShowAllServices(true);
          }}
        />
        <JoinCommunitySection />
      </div>
    );
  }

  // Show All Services Page
  if (showAllServices) {
    return (
      <div className="women-services-container">
        <Header 
          onSignIn={() => setShowLoginPage(true)}
          onJoinNow={() => setShowSignup(true)}
          onAbout={() => setShowAbout(true)}
          onServices={() => {}} // Already on services page
          onHome={handleBackToHome} // Navigate back to home
          currentPage="services" // Set current page to services
        />
        <ViewAllService 
          onBack={handleBackToHome}
          onSignIn={() => {
            setShowAllServices(false);
            setShowLoginPage(true);
          }}
          onJoinNow={() => {
            setShowAllServices(false);
            setShowSignup(true);
          }}
          onAbout={() => {
            setShowAllServices(false);
            setShowAbout(true);
          }}
          // Pass API functions and data to ViewAllService
          fetchSpecializations={fetchSpecializations}
          fetchServicesByCategory={fetchServicesByCategory}
          searchResults={searchResults}
          searchLoading={searchLoading}
          businessData={businessData}
          services={services}
          loading={loading}
          activeSpec={activeSpec}
          setActiveSpec={handleSpecSelection}
        />
      </div>
    );
  }

  return (

     <>
     
      <Helmet>
      <title>Women Connect | Yuukke – Empowering Women Entrepreneurs</title>
      <meta
        name="description"
        content="Join Yuukke Women Connect — a platform for women entrepreneurs and professionals to network, find services, and grow together."
      />
      <meta
        name="keywords"
        content="women entrepreneurs, women professionals, women business, networking, mentorship, empowerment"
      />
      <link
        rel="canonical"
        href="https://connect.yuukke.com/women-connect"
      />
      <meta property="og:title" content="Yuukke Women Connect" />
      <meta
        property="og:description"
        content="Discover Yuukke Women Connect — empowering women through community, mentorship, and business opportunities."
      />
      <meta
        property="og:image"
        content="https://corporate.yuukke.com/bcav2/auth/image/22cb040b-f51d-47e6-8588-42eac1d8c909"
      />
      <meta property="og:url" content="https://connect.yuukke.com/women-connect" />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Yuukke Women Connect" />
      <meta
        name="twitter:description"
        content="Empowering women entrepreneurs and professionals to connect and grow."
      />
      <meta
        name="twitter:image"
        content="https://corporate.yuukke.com/bcav2/auth/image/22cb040b-f51d-47e6-8588-42eac1d8c909"
      />
    </Helmet>

    <div className="women-landing-page-container">
      <Header 
        onSignIn={() => setShowLoginPage(true)}
        onJoinNow={() => setShowSignup(true)}
        onAbout={() => setShowAbout(true)}
        onServices={() => setShowAllServices(true)} // Navigate to services page
        onHome={() => {}} // Already on home page
        currentPage="home" // Set current page to home
      />
      
     <Hero onSearch={handleHeroSearch} />
      <ServiceFinder
        activeSpec={activeSpec}
        setActiveSpec={handleSpecSelection}
        searchResults={searchResults}
        searchLoading={searchLoading}
        onSearch={handleSearch}

      />
      <FeaturedServices
        businessData={businessData}
        services={services}
        loading={loading}
        coverImage={activeCoverImage}
        setShowAllServices={setShowAllServices}
        searchResults={searchResults}
      />
      <JoinCommunitySection />
    </div>
     
     </>


  );
};

export default WomenConnectLanding;
